import { BookOpen, Bot, CircleHelp, House, LifeBuoy, Shield, UserRound, Users } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import type { ListNavGroup } from "@/components/ListNav";
import type { HelpGroupId } from "./articles";
import type { HelpArticle } from "./useHelpArticles";

export const GROUP_ICON: Record<HelpGroupId, ReactElement<{ size?: number; "aria-label"?: string }>> = {
  start: <BookOpen />,
  use: <CircleHelp />,
  spaces: <Users />,
  build: <Bot />,
  account: <UserRound />,
  admin: <Shield />,
  faq: <LifeBuoy />,
};

/** Help's grouped nav: a home link, then one group per topic with the reader's articles. */
export function useHelpNav(articles: HelpArticle[]): ListNavGroup[] {
  const { t } = useTranslation("help");
  const groups = new Map<HelpGroupId, HelpArticle[]>();
  for (const article of articles) groups.set(article.group, [...(groups.get(article.group) ?? []), article]);
  return [
    { id: "home", label: t("title"), items: [{ to: "/help", label: t("nav.home"), icon: <House />, end: true }] },
    ...[...groups].map(([group, items]) => ({
      id: group,
      label: t(`groups.${group}`),
      items: items.map((article) => ({ to: `/help/${article.slug}`, label: article.title })),
    })),
  ];
}
